module.exports = __webpack_public_path__ + "img/stock5.ee9d4751.png";